import { useEffect } from 'react';
import PropTypes from 'prop-types';
import backgroundImage_dark from "../../assets/flug_windows.png";
import backgroundImage_light from "../../assets/light_windows.png";
import AOS from "aos";

const Hero = ({ theme }) => {
  useEffect(() => {
    AOS.refresh();

    // Dynamisch das Skript basierend auf dem Theme laden
    const container = document.getElementById("search-form-container");

    // Entferne vorhandenes Skript, falls vorhanden
    if (container) {
      while (container.firstChild) {
        container.removeChild(container.firstChild); // Entferne alle vorhandenen Kinder
      }
    }

    // Neues Skript basierend auf dem Theme hinzufügen
    const script = document.createElement("script");
    script.src =
      theme === "dark"
        ? "https://tp.media/content?currency=eur&trs=383965&shmarker=601922&show_hotels=false&powered_by=false&locale=de&searchUrl=www.aviasales.com%2Fsearch&primary_override=%23B62629&color_button=%23B62629&color_icons=%23B62629&dark=%23262626&light=%23000000&secondary=%23000000&special=%23C4C4C4&color_focused=%23B62629&border_radius=15&no_labels=true&plain=true&promo_id=7879&campaign_id=100"
        : "https://tp.media/content?currency=eur&trs=383965&shmarker=601922&show_hotels=false&powered_by=false&locale=de&searchUrl=www.aviasales.com%2Fsearch&primary_override=%23B62629&color_button=%23B62629&color_icons=%23B62629&dark=%23262626&light=%23FFFFFF&secondary=%23FFFFFF&special=%23C4C4C4&color_focused=%23B62629&border_radius=15&no_labels=true&plain=true&promo_id=7879&campaign_id=100";
    script.async = true;
    script.charset = "utf-8";
    container.appendChild(script);
  }, [theme]); // Abhängigkeit auf `theme`

  const backgroundImage = theme === "dark" ? backgroundImage_dark : backgroundImage_light;

  return (
    <div
      className="relative dark:bg-black duration-300 pb-10 bg-cover bg-no-repeat bg-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: '#F1F5F9',
      }}
    >
      <div className="container relative z-10 min-h-[300px] flex flex-col">
          <div className="flex justify-center items-center text-center h-[0px] md:h-[250px]">
            <div className="absolute inset-0"></div>
          </div>
               
          {/* Search Form Section */}
        <div className="mt-20 sm:w-auto w-full mt">
          <div className="bg-gray-100 dark:bg-black p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold text-center mb-4 text-black dark:text-gray-200">
              Willkommen bei der Flug Suche
            </h2>
            <div
              id="search-form-container"
              className="flex justify-center items-center"
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

Hero.propTypes = {
  theme: PropTypes.string.isRequired,
};

export default Hero;
